import React from "react";

import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { Box, Button, Typography } from "@mui/material";
import { useReportsQueriesSelector } from "store";

import { GroupByCurrency } from "../../reports/Group-by-currency/GroupByCurrency";
import { GroupByMenu } from "../../reports/Group-by-menu/GroupByMenu";

interface Props {
  label: string;
}

export const SelectCurrencyField: React.FC<Props> = ({ label }) => {
  const { currency } = useReportsQueriesSelector();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        p: "2px 10px",
        height: "32px",
        borderRadius: "999px",
        border: "1px solid #dbe8f5",
        bgcolor: "#FFFFFF",
        position: "relative"
      }}
    >
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          color: "#92a7bc",
          textTransform: "uppercase",
          flexShrink: 0
        }}
      >
        {label}
      </Typography>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <GroupByMenu
          renderTrigger={(params) => (
            <Button
              {...params}
              sx={{
                bgcolor: "#ffffff",
                padding: "2px 8px 2px 0",
                border: "none",
                minWidth: 0,
                fontSize: 12,
                fontWeight: 700,
                color: "#071f35",
                minHeight: 0,
                height: "24px",
                borderRadius: 0,
                textTransform: "none",
                "&:hover": {
                  bgcolor: "transparent"
                }
              }}
              endIcon={<ArrowDropDown sx={{ color: "#5d7782" }} />}
            >
              {currency}
            </Button>
          )}
        >
          <GroupByCurrency />
        </GroupByMenu>
      </Box>
    </Box>
  );
};
